import React, { useState, useRef, useCallback } from 'react';
import { SubmitHandler, FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useValidation, useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';
import * as S from './styles';

import { Modal } from 'components/shared';
import { Input, InputDate, ToggleInput } from 'components/shared/Form';
import { useFilters } from 'hooks/useFilters';

export const FilterAlertEmailLogs: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors } = useValidation();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [cleanShow, setCleanShow] = useState<boolean>(false);

  const { setFilter } = useFilters('alertEmailLogs', {
    formRef,
    fieldConfig: { dateInicio: 'date', dateFim: 'date' },
  });

  const handleSubmit = useCallback<SubmitHandler>(
    async (data: any) => {
      try {
        setFilter(data);

        setCleanShow(true);
        setModalOpen(false);
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [handleFormErrors]
  );

  const handleFilterClean = useCallback(() => {
    if (formRef.current) {
      formRef.current.setFieldValue('email', '');
      formRef.current.setFieldValue('assunto', '');
      formRef.current.setFieldValue('dateInicio', '');
      formRef.current.setFieldValue('dateFim', '');
      const clean = {
        email: '',
        assunto: '',
        dateInicio: '',
        dateFim: '',
      };
      setFilter(clean);
    }

    setCleanShow(false);
    setModalOpen(false);
  }, []);

  const renderButtonCleanFilter = () => {
    if (cleanShow) {
      return (
        <S.ButtonMini btStyle="dark" onClick={handleFilterClean}>
          Limpar filtro
        </S.ButtonMini>
      );
    }
  };

  return (
    <S.Container>
      <Modal isOpen={modalOpen}>
        <S.ModalContainer>
          <S.Header>
            <S.IconFilter />
            <S.Title>{getTranslation('filtrar')}</S.Title>
          </S.Header>
          <Form placeholder={''} ref={formRef} onSubmit={handleSubmit}>
            <S.FormRow>
              <Input name="email" label={getTranslation('destinatario')} />
              <Input name="assunto" label={getTranslation('assunto')} />
              {checkUserPermission('resendAlert') && (
                <ToggleInput
                  name="is_error"
                  label={getTranslation('naoEnviados')}
                />
              )}
            </S.FormRow>

            <S.FormRow>
              <InputDate
                name="dateInicio"
                label={getTranslation('dateInicio')}
              />
              <InputDate name="dateFim" label={getTranslation('dateFim')} />
            </S.FormRow>

            <S.ButtonsWrapper>
              <S.Button
                btStyle="cancel"
                onClick={() => setModalOpen(false)}
                type="button"
              >
                {getTranslation('fechar')}
              </S.Button>
              <S.Button
                btStyle="danger"
                type="button"
                onClick={handleFilterClean}
              >
                {getTranslation('limparFiltro')}
              </S.Button>
              <S.Button type="submit">{getTranslation('filtrar')}</S.Button>
            </S.ButtonsWrapper>
          </Form>
        </S.ModalContainer>
      </Modal>

      {renderButtonCleanFilter()}
      <S.ButtonFilter onClick={() => setModalOpen(true)}>
        <S.IconFilter />
      </S.ButtonFilter>
    </S.Container>
  );
};
